import React, { useState } from 'react';
import styles from '../styles/addMultiProductDrawer.module.css';
import CustomSelect from '../customComponents/CustomSelect';

const AddMultiProductDrawer = ({ onClose }) => {
  const [step, setStep] = useState(1);
  const [type, setType] = useState('');
  const [UnitsOfMeasurement, setUnitsOfMeasurement] = useState('');
  const [barcode, setBarcode] = useState('');
  const [image, setImage] = useState(null);

  const [characteristics, setCharacteristics] = useState([]);

  const addCharacteristic = () => {
    setCharacteristics((prev) => [
      ...prev,
      {
        id: Date.now(),
        name: '',
        values: [''],
      },
    ]);
  };

  // Функция добавить новое значение в характеристику с заданным id
  const addValue = (charId) => {
    setCharacteristics((prev) =>
      prev.map((char) =>
        char.id === charId
          ? { ...char, values: [...(char.values || []), ''] }
          : char
      )
    );
  };

  // Функция изменить значение input'а
  const updateValue = (charId, index, newValue) => {
    setCharacteristics((prev) =>
      prev.map((char) => {
        if (char.id === charId) {
          const currentValues = Array.isArray(char.values) ? char.values : [];
          const newValues = [...currentValues];
          newValues[index] = newValue;
          return { ...char, values: newValues };
        }
        return char;
      })
    );
  };

  // Функция удалить характеристику по id
  const deleteCharacteristic = (charId) => {
    setCharacteristics((prev) => prev.filter((char) => char.id !== charId));
  };

  const handleNext = () => {
    if (step < 4) setStep(step + 1);
  };

  const handleBack = () => {
    if (step > 1) setStep(step - 1);
  };

  const handleCreate = () => {
    console.log('Товар создан!');
    onClose();
  };

  const generateBarcode = () => {
    const random13Digit = Math.floor(Math.random() * 9e12 + 1e12).toString();
    setBarcode(random13Digit);
  };

  const handleImageUpload = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const validTypes = ['image/png', 'image/jpeg'];
    const maxSize = 1024 * 1024;

    if (!validTypes.includes(file.type)) {
      alert('Неверный формат. Допустимы только PNG или JPG.');
      return;
    }

    if (file.size > maxSize) {
      alert('Файл слишком большой. Максимум 1MB.');
      return;
    }

    const img = new Image();
    img.src = URL.createObjectURL(file);

    img.onload = () => {
      const { width, height } = img;

      if (width !== 1080 || height !== 1080) {
        alert(`Неверное разрешение. Требуется 1080x1080 пикселей.`);
        return;
      }

      if (width / height !== 1) {
        alert('Соотношение сторон должно быть 1:1.');
        return;
      }

      setImage(img.src);
    };
  };

  const renderStepIndicator = () => (
    <div className={styles.stepIndicator}>
      {[
        'Основная информация',
        'Создание характеристик',
        'Свойства характеристик',
        'Дополнительный настройки',
      ].map((label, index) => {
        const stepNumber = index + 1;
        const isActive = step >= stepNumber;
        return (
          <div
            key={stepNumber}
            className={`${styles.stepItem} ${isActive ? styles.active : ''}`}
          >
            <div className={styles.circle}>{stepNumber}</div>
            <span className={styles.stepLabel}>{label}</span>
            {stepNumber < 4 && <div className={styles.stepLine}></div>}
          </div>
        );
      })}
    </div>
  );

  const renderStepContent = () => {
    switch (step) {
      case 1:
        return (
          <>
            <div className={styles.formSection}>
              <h3>Общая информация</h3>
              <div className={styles.grid}>
                <input className={styles.input} type="text" placeholder="Наименование" />
                <CustomSelect
                  className={styles.filters__select}
                  options={['Автозапчасти', 'Бытовая техника', 'Электроника', 'Компьютеры и комплектующие']}
                  value={type}
                  onChange={setType}
                  placeholder="Категория"
                />
                <CustomSelect
                  className={styles.filters__select}
                  options={['ШТ', 'УПАК', 'ПАРА', 'НАБ']}
                  value={UnitsOfMeasurement}
                  onChange={setUnitsOfMeasurement}
                  placeholder="Единица измерения"
                />
                <input className={styles.input} type="text" placeholder="0023940234233" />
              </div>
            </div>

            <div className={styles.section}>
              <h3>Штрихкод</h3>
              <div className={styles.barcodeRow}>
                <div className={styles.barcodeRowBlock}>
                  <input className={styles.input} placeholder="Штрихкод" value={barcode} readOnly />
                </div>
                <button className={styles.link}>+ Добавить доп. штрихкод</button>
              </div>
              <button className={styles.barcodeRowRandom} onClick={generateBarcode}>
                Сгенерировать
              </button>
            </div>

            <div className={styles.section}>
              <h3>Фото</h3>
              <div
                className={styles.uploadBox}
                onClick={() => document.getElementById('photoInput')?.click()}
              >
                {image ? (
                  <img src={image} alt="preview" className={styles.previewImage} />
                ) : (
                  <div className={styles.uploadPlaceholder}>
                    <p className={styles.uploadPlaceholderPlus}>+</p>
                    <p className={styles.uploadPlaceholderText}>Загрузить фото</p>
                  </div>
                )}

                <input
                  type="file"
                  id="photoInput"
                  accept="image/png, image/jpeg"
                  onChange={handleImageUpload}
                  style={{ display: 'none' }}
                />

                <p className={styles.uploadInfo}>
                  Тип файла: <strong>PNG, JPG</strong>
                  <br />
                  Соотношение сторон: <strong>1:1 (квадрат)</strong>
                  <br />
                  Разрешение: <strong>1080×1080 px</strong>
                  <br />
                  Максимальный размер: <strong>1Mb</strong>
                </p>
              </div>
            </div>
          </>
        );

      case 2:
        return (
          <>
            <h3>Добавьте характеристики данному товару</h3>

            {characteristics.length === 0 && (
              <p>Пока нет характеристик. Нажмите "Выберите характеристику".</p>
            )}

            {characteristics.map(({ id, name, values }) => (
              <div key={id} className={styles.characteristicSection}>
                <div className={styles.inputRow}>
                  <input
                    type="text"
                    placeholder="Имя характеристики"
                    className={styles.input}
                    value={name}
                    onChange={(e) =>
                      setCharacteristics((prev) =>
                        prev.map((char) =>
                          char.id === id ? { ...char, name: e.target.value } : char
                        )
                      )
                    }
                  />

                  <input
                    type="text"
                    placeholder="Укажите значение"
                    className={styles.input}
                    value={(values && values[0]) || ''}
                    onChange={(e) => updateValue(id, 0, e.target.value)}
                    style={{ marginLeft: '10px' }}
                  />

                  <button
                    className={styles.deleteButton}
                    onClick={() => deleteCharacteristic(id)}
                    style={{ marginLeft: '10px' }}
                  >
                    Удалить
                  </button>
                </div>

                <div style={{ marginTop: '10px' }}>
                  <button
                    type="button"
                    className={styles.link}
                    onClick={() => addValue(id)}
                  >
                    + Добавить значение
                  </button>
                </div>
              </div>
            ))}

            <div style={{ marginTop: '15px' }}>
              <button className={styles.myButtonClass} onClick={addCharacteristic}>
                Выберите характеристику
              </button>
            </div>
          </>
        );

      case 3:
        return <h3>Этап 3: Свойства характеристик</h3>;
      case 4:
        return <h3>Этап 4: Дополнительные настройки</h3>;
      default:
        return null;
    }
  };

  return (
    <div className={styles.drawer}>
      <div className={styles.header}>
        <button className={styles.closeButton} onClick={onClose}></button>
        <h2 className={styles.headerText}>Добавление многотипного товара</h2>
      </div>

      {renderStepIndicator()}

      <div className={styles.body}>
        {renderStepContent()}

        <div className={styles.footer}>
          {step > 1 && (
            <button className={styles.back} onClick={handleBack}>
              Назад
            </button>
          )}

          {step < 4 ? (
            <button className={styles.submit} onClick={handleNext}>
              Далее
            </button>
          ) : (
            <button className={styles.submit} onClick={handleCreate}>
              Создать товар
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddMultiProductDrawer;
